export const todayStr = new Date().toISOString().split('T')[0];

export const buildInitialUser = (user) => ({
  first_Name: user?.FirstName ?? '',
  last_Name: user?.LastName ?? '',
  typeIdentificationNumber: user?.FK_TypeId ?? '',
  role: user?.FK_Role ?? '',
  identificationNumber: user?.NumeroIdentificacion ?? '',
  confirmIdentificationNumber: '',
  country: user?.FK_Country ?? '',
  cityId: user?.FK_City ?? '',
  email: user?.PrincipalEmail ?? '',
  alternativeEmail: user?.AlternativeEmail ?? '',
  cellPhone: user?.Phone ?? '',
  phone: user?.Phone2 ?? '',
  birthdate: user?.Birthdate ?? todayStr,
  password: '',
  confirmPassword: '',
  stage: '',
  motivation: user?.FK_Motivation ?? '',
});

export const buildInitialProfessional = (prof) => ({
  profession: prof?.Title ?? '',
  company: prof?.Name ?? '',
  currentPosition: prof?.Position ?? '',
});

export const buildInitialStudent = (student) => ({
  studyLevel: student?.Level ?? '',
  career: student?.Career ?? '',
  university: student?.Name ?? '',
  semester: student?.Semester ?? '',
});
